import { PlatformDevice } from '@/models/platformDevice'

type SortColumn = keyof PlatformDevice | null
type SortDirection = 'asc' | 'desc'

interface PlatformDeviceTableHeaderProps {
  columnWidths: number[]
  sortColumn: SortColumn
  sortDirection: SortDirection
  onSort: (column: keyof PlatformDevice) => void
  onResizeStart: (e: React.MouseEvent, index: number) => void
}

export default function PlatformDeviceTableHeader({
  columnWidths,
  sortColumn,
  sortDirection,
  onSort,
  onResizeStart
}: PlatformDeviceTableHeaderProps) {

  const getSortIcon = (column: keyof PlatformDevice) => {
    if (sortColumn !== column) return '↕'
    return sortDirection === 'asc' ? '↑' : '↓'
  }

  return (
    <thead>
      <tr>
        <th
          onClick={() => onSort('serialNumber')}
          className="sortable resizable"
          title="Device Serial Number"
          style={{ width: `${columnWidths[1]}px` }}
        >
          <span>Serial # {getSortIcon('serialNumber')}</span>
          <div
            className="resize-handle"
            onMouseDown={(e) => onResizeStart(e, 1)}
          />
        </th>

        <th
          onClick={() => onSort('imei')}
          className="sortable resizable"
          title="IMEI Number"
          style={{ width: `${columnWidths[2]}px` }}
        >
          <span>IMEI {getSortIcon('imei')}</span>
          <div
            className="resize-handle"
            onMouseDown={(e) => onResizeStart(e, 2)}
          />
        </th>

        <th
          onClick={() => onSort('type')}
          className="sortable resizable"
          title="Device Type"
          style={{ width: `${columnWidths[3]}px` }}
        >
          <span>Type {getSortIcon('type')}</span>
          <div
            className="resize-handle"
            onMouseDown={(e) => onResizeStart(e, 3)}
          />
        </th>

        <th
          onClick={() => onSort('partnerName')}
          className="sortable resizable"
          title="Channel Partner"
          style={{ width: `${columnWidths[4]}px` }}
        >
          <span>Partner {getSortIcon('partnerName')}</span>
          <div
            className="resize-handle"
            onMouseDown={(e) => onResizeStart(e, 4)}
          />
        </th>

        <th
          onClick={() => onSort('phoneNumber')}
          className="sortable resizable"
          title="Phone Number"
          style={{ width: `${columnWidths[4]}px` }}
        >
          <span>Phone {getSortIcon('phoneNumber')}</span>
          <div
            className="resize-handle"
            onMouseDown={(e) => onResizeStart(e, 4)}
          />
        </th>

        <th
          onClick={() => onSort('simSerialNumber')}
          className="sortable resizable"
          title="SIM Serial Number"
          style={{ width: `${columnWidths[5]}px` }}
        >
          <span>SIM # {getSortIcon('simSerialNumber')}</span>
          <div
            className="resize-handle"
            onMouseDown={(e) => onResizeStart(e, 5)}
          />
        </th>

        <th
          onClick={() => onSort('simProviderName')}
          className="sortable resizable"
          title="SIM Provider"
          style={{ width: `${columnWidths[6]}px` }}
        >
          <span>Provider {getSortIcon('simProviderName')}</span>
          <div
            className="resize-handle"
            onMouseDown={(e) => onResizeStart(e, 6)}
          />
        </th>

        <th
          onClick={() => onSort('firmware')}
          className="sortable resizable"
          title="Firmware Version"
          style={{ width: `${columnWidths[9]}px` }}
        >
          <span>Firmware {getSortIcon('firmware')}</span>
          <div
            className="resize-handle"
            onMouseDown={(e) => onResizeStart(e, 9)}
          />
        </th>

        <th
          onClick={() => onSort('configurationId')}
          className="sortable resizable"
          title="Configuration Name"
          style={{ width: `${columnWidths[10]}px` }}
        >
          <span>Configuration {getSortIcon('configurationId')}</span>
          <div
            className="resize-handle"
            onMouseDown={(e) => onResizeStart(e, 10)}
          />
        </th>

        <th
          onClick={() => onSort('dateAddedUtc')}
          className="sortable resizable"
          title="Date Added"
          style={{ width: `${columnWidths[11]}px` }}
        >
          <span>Added {getSortIcon('dateAddedUtc')}</span>
          <div
            className="resize-handle"
            onMouseDown={(e) => onResizeStart(e, 11)}
          />
        </th>

        <th
          className="resizable"
          title="Config Update Status"
          style={{ width: `${columnWidths[12]}px` }}
        >
          <span>Configuration Status</span>
          <div
            className="resize-handle"
            onMouseDown={(e) => onResizeStart(e, 12)}
          />
        </th>

        <th
          className="resizable"
          title="Firmware Update Status"
          style={{ width: `${columnWidths[13]}px` }}
        >
          <span>Firmware Status</span>
          <div
            className="resize-handle"
            onMouseDown={(e) => onResizeStart(e, 13)}
          />
        </th>
      </tr>
    </thead>
  )
}

export type { SortColumn, SortDirection }